module.exports = __webpack_public_path__ + "static/media/member9.68254da7.png";